import { Modal } from "antd";
import { useTranslation } from "react-i18next";

interface Props {
    open: boolean;
    onClose: () => void;
}

export default function CustomerDetailsModal({
    open,
    onClose,
}: Props) {
    const { t } = useTranslation();
    const data = [
        { label: t('cd.fullname'), value: "99785075859547" },
        { label: t('cd.email'), value: "" },
        { label: t('cd.phone_label'), value: "99785075859547" },
        { label: t('cd.address'), value: "18 Huỳnh Lan Khanh P.2 Quận Tân Bình TP.HCM" },
        { label: t('cd.notes'), value: "0909506018" },
        { label: t('cd.nickname'), value: "99785075859547" },
        { label: t('cd.first_contact_time'), value: "27/02/2026 12:36" },
        { label: t('cd.last_contact_time'), value: "27/02/2026 12:36" },
    ];

    return (
        <Modal
            title={t('cd.detail_title')}
            open={open}
            onCancel={onClose}
            footer={null}
            width={650}
            centered
            className="dark:[&_.ant-modal-content]:bg-[#141414]
                 dark:[&_.ant-modal-header]:bg-[#141414]
                 dark:[&_.ant-modal-title]:text-gray-200"
        >
            <div className="rounded-lg border border-gray-200 dark:border-[#303030] overflow-hidden">
                {data.map((item, index) => (
                    <div
                        key={index}
                        className="grid grid-cols-2 border-b last:border-none
                       border-gray-200 dark:border-[#303030]"
                    >
                        <div className="bg-gray-50 dark:bg-[#1f1f1f]
                            px-4 py-3 text-gray-600 dark:text-gray-400">
                            {item.label}
                        </div>
                        <div className="px-4 py-3 text-gray-800 text-000000e0">
                            {item.value || "—"}
                        </div>
                    </div>
                ))}
            </div>
        </Modal>
    );
}